// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --primary-color: #4C6D59;
  --dark-overlay: rgba(0, 0, 0, 0.4);
  --font-main: "Roboto", sans-serif;
}

.News_news-container__YXnR9 {
  width: 100%;
}

.News_news-section-one__JaMOp {
  width: 100%;
  height: 100vh;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("https://i.imgur.com/IzMCeZN.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

.News_hh__iR4rf {
  color: white;
  font-weight: 700;
  font-family: var(--font-main);
  font-size: clamp(36px, 6vw, 96px);
  text-align: start;
  margin-top: 380px;
  margin-left: 120px;
}

.News_news-section-two__NntK\\+ {
  width: 80%;
  margin: 100px auto 150px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 30px;
}

.News_child__KECTM {
  width: 428px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
}

.News_child__KECTM div {
  width: 100%;
  height: 354px;
}

.News_child__KECTM h3 {
  color: var(--primary-color);
  font-family: var(--font-main);
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  margin-top: 12px;
}

.News_child__KECTM p {
  color: var(--primary-color);
  font-family: var(--font-main);
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 8px;
  text-align: justify;
}

/* Images */
.News_dubai-img__caYA6,
.News_umex-img__WzheF,
.News_abudabi-img__pcMTN,
.News_deffa-img__ONLco,
.News_dubai-two-img__aEfbM,
.News_umex-two-img__7JW7L,
.News_china-img__aI3Hq,
.News_paris-img__fMUqx,
.News_demirchyan-img__D94rr {
  width: 100%;
  height: 354px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

/* Specific backgrounds */
.News_dubai-img__caYA6 {
  background-image: url("https://i.imgur.com/sGyXESa.jpeg");
}

.News_umex-img__WzheF {
  background-image: url("https://i.imgur.com/IwAixru.jpeg");
}

.News_abudabi-img__pcMTN {
  background-image: url("https://i.imgur.com/UPgHM1g.jpeg");
}

.News_deffa-img__ONLco {
  background-image: url("https://i.imgur.com/XJcIAuB.jpeg");
}

.News_dubai-two-img__aEfbM {
  background-image: url("https://i.imgur.com/x558I9q.jpeg");
}

.News_umex-two-img__7JW7L {
  background-image: url("https://i.imgur.com/xhMvKlV.jpeg");
}

.News_china-img__aI3Hq {
  background-image: url("https://i.imgur.com/ZSYFvIp.jpeg");
}

.News_paris-img__fMUqx {
  background-image: url("https://i.imgur.com/iUh7fjA.jpeg");
}

.News_demirchyan-img__D94rr {
  background-image: url("https://i.imgur.com/gtR1hpu.jpeg");
}

/* 📱 Tablet */
@media screen and (max-width: 1024px) {
  .News_news-section-two__NntK\\+ {
    width: 90%;
    margin-top: 80px;
  }
  .News_news-section-one__JaMOp {
    height: 50vh;
  }
  .News_child__KECTM {
    width: 320px;
  }
  .News_child__KECTM div {
    height: 280px;
  }
  .News_child__KECTM h3 {
    font-size: 20px;
  }
  .News_child__KECTM p {
    font-size: 16px;
  }
}
/* 📱 Mobile */
@media screen and (max-width: 600px) {
  .News_news-section-one__JaMOp {
    height: 50vh;
  }
  .News_hh__iR4rf {
    font-size: clamp(24px, 5vw, 40px);
    margin-top: 0;
    padding: 10px;
    margin-left: -50px;
    text-align: center;
    margin-top: 200px;
  }
  .News_news-section-two__NntK\\+ {
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
  }
  .News_child__KECTM {
    width: 90%;
  }
  .News_child__KECTM div {
    height: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/News/News.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,wBAAA;EACA,kCAAA;EACA,iCAAA;AAEF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EAEA,4GAAA;EAGA,sBAAA;EACA,4BAAA;AAFF;;AAMA;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,UAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;AAHF;;AAMA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AAHF;;AAMA;EACE,WAAA;EACA,aAAA;AAHF;;AAMA;EACE,2BAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,2BAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAHF;;AAMA,WAAA;AACA;;;;;;;;;EASE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AAHF;;AAMA,yBAAA;AACA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA,cAAA;AACA;EACE;IACE,UAAA;IACA,gBAAA;EAHF;EAOA;IACE,YAAA;EALF;EASA;IACE,YAAA;EAPF;EAUA;IACE,aAAA;EARF;EAWA;IACE,eAAA;EATF;EAYA;IACE,eAAA;EAVF;AACF;AAaA,cAAA;AACA;EACE;IACE,YAAA;EAXF;EAeA;IACE,iCAAA;IACA,aAAA;IACA,aAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;EAbF;EAgBA;IACE,sBAAA;IACA,mBAAA;IACA,gBAAA;EAdF;EAiBA;IACE,UAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;AACF","sourcesContent":[":root {\n  --primary-color: #4C6D59;\n  --dark-overlay: rgba(0, 0, 0, 0.4);\n  --font-main: 'Roboto', sans-serif;\n\n}\n\n.news-container {\n  width: 100%;\n}\n\n.news-section-one {\n  width: 100%;\n  height: 100vh;\n  //background-color: #2e2e2e;\n  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(\"https://i.imgur.com/IzMCeZN.jpeg\");;\n\n  //background-image: url(\"../Images/newsbg.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n\n.hh {\n  color: white;\n  font-weight: 700;\n  font-family: var(--font-main);\n  font-size: clamp(36px, 6vw, 96px);\n  text-align: start;\n  margin-top: 380px;\n  margin-left: 120px;\n}\n\n.news-section-two {\n  width: 80%;\n  margin: 100px auto 150px auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  gap: 30px;\n}\n\n.child {\n  width: 428px;\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n}\n\n.child div {\n  width: 100%;\n  height: 354px;\n}\n\n.child h3 {\n  color: var(--primary-color);\n  font-family: var(--font-main);\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-top: 12px;\n}\n\n.child p {\n  color: var(--primary-color);\n  font-family: var(--font-main);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin-top: 8px;\n  text-align: justify;\n}\n\n/* Images */\n.dubai-img,\n.umex-img,\n.abudabi-img,\n.deffa-img,\n.dubai-two-img,\n.umex-two-img,\n.china-img,\n.paris-img,\n.demirchyan-img {\n  width: 100%;\n  height: 354px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n/* Specific backgrounds */\n.dubai-img {\n  background-image: url(\"https://i.imgur.com/sGyXESa.jpeg\");\n}\n\n.umex-img {\n  background-image: url(\"https://i.imgur.com/IwAixru.jpeg\");\n}\n\n.abudabi-img {\n  background-image: url(\"https://i.imgur.com/UPgHM1g.jpeg\");\n}\n\n.deffa-img {\n  background-image: url(\"https://i.imgur.com/XJcIAuB.jpeg\");\n}\n\n.dubai-two-img {\n  background-image: url(\"https://i.imgur.com/x558I9q.jpeg\");\n}\n\n.umex-two-img {\n  background-image: url(\"https://i.imgur.com/xhMvKlV.jpeg\");\n}\n\n.china-img {\n  background-image: url(\"https://i.imgur.com/ZSYFvIp.jpeg\");\n}\n\n.paris-img {\n  background-image: url(\"https://i.imgur.com/iUh7fjA.jpeg\");\n}\n\n.demirchyan-img {\n  background-image: url(\"https://i.imgur.com/gtR1hpu.jpeg\");\n}\n\n/* 📱 Tablet */\n@media screen and (max-width: 1024px) {\n  .news-section-two {\n    width: 90%;\n    margin-top: 80px;\n\n  }\n\n  .news-section-one{\n    height: 50vh;\n  }\n\n\n  .child {\n    width: 320px;\n  }\n\n  .child div {\n    height: 280px;\n  }\n\n  .child h3 {\n    font-size: 20px;\n  }\n\n  .child p {\n    font-size: 16px;\n  }\n}\n\n/* 📱 Mobile */\n@media screen and (max-width: 600px) {\n  .news-section-one {\n    height: 50vh;\n\n  }\n\n  .hh {\n    font-size: clamp(24px, 5vw, 40px);\n    margin-top: 0;\n    padding: 10px;\n    margin-left: -50px;\n    text-align: center;\n    margin-top: 200px;\n  }\n\n  .news-section-two {\n    flex-direction: column;\n    align-items: center;\n    margin-top: 60px;\n  }\n\n  .child {\n    width: 90%;\n  }\n\n  .child div {\n    height: 250px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"news-container": `News_news-container__YXnR9`,
	"news-section-one": `News_news-section-one__JaMOp`,
	"hh": `News_hh__iR4rf`,
	"news-section-two": `News_news-section-two__NntK+`,
	"child": `News_child__KECTM`,
	"dubai-img": `News_dubai-img__caYA6`,
	"umex-img": `News_umex-img__WzheF`,
	"abudabi-img": `News_abudabi-img__pcMTN`,
	"deffa-img": `News_deffa-img__ONLco`,
	"dubai-two-img": `News_dubai-two-img__aEfbM`,
	"umex-two-img": `News_umex-two-img__7JW7L`,
	"china-img": `News_china-img__aI3Hq`,
	"paris-img": `News_paris-img__fMUqx`,
	"demirchyan-img": `News_demirchyan-img__D94rr`
};
export default ___CSS_LOADER_EXPORT___;
